import React, { FC } from 'react';
import styles from './NoResult.module.scss';
import { useRouter } from 'next/router';
import { addRecentSearch } from '@/helpers/props';
import Icon from '@/components/UI/icon/Icon';
import Box from '@/components/UI/box/Box';
import Typography from '@/components/UI/typography/Typography';
type Props = {
  searchTxt: string;
  closeHandler: () => void;
  isMidTerm: boolean;
};
const NoResult: FC<Props> = ({
  searchTxt,
  closeHandler,
  isMidTerm
}) => {
  const router = useRouter();
  return searchTxt.includes('شمال') && !isMidTerm ? <Box onClick={() => {
    router.push({
      pathname: '/search',
      query: {
        phrase: 'شمال'
      }
    });
    addRecentSearch({
      name: 'شمال',
      type: 'phrase'
    });
    closeHandler();
  }} className={`${styles['container']} ${styles['north-no-result']}`} data-sentry-element="Box" data-sentry-component="NoResult" data-sentry-source-file="NoResult.tsx">
      <Icon name="location" type="primary" data-sentry-element="Icon" data-sentry-source-file="NoResult.tsx" />
      <Typography variant={'bodyS'} data-sentry-element="Typography" data-sentry-source-file="NoResult.tsx">همه اقامتگاه‌های شمال</Typography>
    </Box> : <Box onClick={() => {
    router.push({
      pathname: isMidTerm ? '/search/city/تهران' : '/search',
      query: {
        phrase: searchTxt,
        ...(isMidTerm ? {
          mid_term: 1
        } : {})
      }
    });
    addRecentSearch({
      name: searchTxt,
      type: 'phrase'
    });
    closeHandler();
  }} className={`${styles['container']} ${styles['no-result']}`} data-sentry-element="Box" data-sentry-component="NoResult" data-sentry-source-file="NoResult.tsx">
      <Typography variant={'bodyS'} data-sentry-element="Typography" data-sentry-source-file="NoResult.tsx">
        جستجو عبارت {`"${searchTxt}"`} در سایت
      </Typography>
      <Icon name={'arrow-left'} type={'highEmphasis'} data-sentry-element="Icon" data-sentry-source-file="NoResult.tsx" />
    </Box>;
};
export default NoResult;